import { resendVerification } from 'api/services';
import { useCallback } from 'react';
import { useMutation, UseMutationOptions } from 'react-query';
import { useProfileInfo } from './useProfile';

export default function useVerifyEmail(
  config?: UseMutationOptions<void, unknown, void, unknown>,
) {
  const { data: userInfo } = useProfileInfo();
  const { userId } = userInfo ?? {};

  const mutationFn = useCallback(async () => {
    if (userId) {
      resendVerification(userId);
    }
  }, [userId]);

  return useMutation<void, unknown, void, unknown>(mutationFn, config);
}
